import {Row} from "react-bootstrap";
import * as AiIcons from "react-icons/ai";

function Message(status, setStatus) {
    return (
        <div>
        {
            status === "" ?
                <div/> :
                <Row style={{
                    marginTop: '10px',
                    display: "flex",
                    justifyContent: "center"
                }}>
                    <div style={{
                        backgroundColor: "lightblue",
                        padding: "7px",
                        borderRadius: "5px",
                        paddingLeft: "13px",
                        width: "92%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <div style={{width: "100%"}}>{status}</div>
                        <AiIcons.AiFillCloseCircle style={{cursor: "pointer"}} onClick={(e) =>setStatus("")} size={18} />
                    </div>

                </Row>
            }
        </div>
    )
}

export default Message